import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const ARTICLEMAININFOGQLSCHEMA = `
Title{
    ${MULTILANGUAGEGQLSCHEMA}
}
Description{
    ${MULTILANGUAGEGQLSCHEMA}
}
`;
export const ARTICLEGQLSCHEMA = `
id
MainInfo{
    ${ARTICLEMAININFOGQLSCHEMA}
}
Slug
Image
Content{
    ${MULTILANGUAGEGQLSCHEMA}
}
Keywords{
    ${MULTILANGUAGEGQLSCHEMA}
}
`;
